import { userAccountant, userAdmin } from "@/app/api";
import { ReactNode } from "react";

interface AccountantAccessProps {
  children: ReactNode;
}

export async function AccountantRoute({ children }: AccountantAccessProps) {
  const isAccountant = await userAccountant();
  const isAdmin = await userAdmin();

  if (isAccountant || isAdmin) {
    return <>{children}</>
  }
  return null
}